module.exports = function(doc) {
  return !!doc.toObject;
};
